import { Button } from 'antd';
import { ArrowUpOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

export const addRowBeforeCommand = ({ editor, range }) =>
  range ? editor.chain().focus().deleteRange(range).addRowBefore().run() : editor.chain().focus().addRowBefore().run();

const AddRowBefore = ({ editor, showLabel = false, isExtension = false }) => {
  return (
    <Button
      className={`editor-toolbar-btn-container !bg-transparent`}
      icon={<ArrowUpOutlined className="text-gray-800 text-xs" />}
      onClick={isExtension ? () => {} : () => addRowBeforeCommand({ editor })}
      size="small"
      type="text"
    >
      {showLabel && (
        <div className="editor-toolbar-btn-label">
          <FormattedMessage id="TABLE_ADD_ROW_BEFORE" defaultMessage="Add row before" />
        </div>
      )}
    </Button>
  );
};

export default AddRowBefore;
